<template>
    <ideo-form-group :label="$t('[[[Kategorię subskrypcji]]]')" :invalid-feedback="form.$errors.first('settings.categories')" :state="form.$errors.state('settings.categories')">
        <edito-subscriptions-categories v-model="form.settings.categories"></edito-subscriptions-categories>
    </ideo-form-group>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { Emit, Prop, Watch } from '@/helpers/Decorators';
import merge from 'lodash/merge';

@Options({
    name: 'module-subscriptions-settings'
})
export default class SubscriptionsSettings extends Vue
{
    @Prop() public modelValue!: any;

    public defaults: any = {
        categories: []
    };

    public get form(): any
    {
        return this.modelValue;
    }

    public created(): void
    {
        this.form.settings = merge(this.defaults, this.form.settings);
    }

    @Watch('form.settings', { deep: true })
    public onSettingsChanged(value: any): void
    {
        this.triggetModel();
    }

    @Emit('update:modelValue')
    public triggetModel(): any
    {
        return this.form;
    }
}
</script>
